import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";

@Injectable()
export class TicketsService {
  constructor(private http: HttpClientService) {}

  public create(
    text: any,
    ticketable_type: string,
    ticketable_id: string | number,
    documents_link: any
  ): Observable<any> {
    const options = {
      ticket_params: {
        body: text,
        ticketable_type: ticketable_type,
        ticketable_id: ticketable_id,
        documents_link: documents_link,
      },
    };
    return this.http.post("/api/tickets", options).pipe(tap((_) => console.log("TicketsService.createTicket: Ok.")));
  }

  public index(ticketable_type: string, ticketable_id: any): Observable<any> {
    const options = {
      params: {
        ticketable_type: ticketable_type,
        ticketable_id: ticketable_id,
      },
    };
    return this.http.get("/api/tickets", options).pipe(tap((_) => console.log("TicketService.getTickets: Ok.")));
  }

  public update(ticket_id, body): Observable<any> {
    const options = {
      update_params: {
        body: body,
      },
    };
    return this.http
      .put(`/api/tickets/${ticket_id}`, options)
      .pipe(tap((_) => console.log("TicketService.updateTicket: Ok")));
  }

  public show(ticket_id): Observable<any> {
    return this.http.get(`/api/tickets/${ticket_id}`).pipe(tap((_) => console.log("TicketService.showTicket: Ok")));
  }

  public contract_form(
    text: any,
    ticketable_type: string,
    ticketable_id: string | number,
    form_type: string
  ): Observable<any> {
    const options = {
      form_params: {
        body: text,
        ticketable_type: ticketable_type,
        ticketable_id: ticketable_id,
        form_type: form_type,
      },
    };
    return this.http
      .post("/api/tickets/contract_form", options)
      .pipe(tap((_) => console.log("TicketsService.contractFormTicket: Ok.")));
  }
}
